import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastProvider } from './components/ui/Toast';
import { SchemaProvider } from './contexts/SchemaContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ToastProvider>
      <SchemaProvider>
        <App />
      </SchemaProvider>
    </ToastProvider>
  </React.StrictMode>
);
